import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme) => ({
  container: {
    overflow: "hidden",
  },
  pdfcontainer: {
    overflowY: "scroll",
    height: "550px",
  },
  pdfdiv: {
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  arrows: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-evenly",
    margin: theme.spacing(1),
  },
}));